import { createSelector } from 'reselect';
const getCommunications = (state) => state.communications;
export const getCategories = createSelector(getCommunications, communications => communications.categories);
export const getUnreadTotal = createSelector(getCommunications, communications => communications.unreadTotal);
export const getLoading = createSelector(getCommunications, communications => communications.loading);
export const isLoadingTeasers = createSelector(getLoading, loading => loading.teasers);
export const isLoadingCategories = createSelector(getLoading, loading => loading.categories);
export const isLoadingMarkAsRead = createSelector(getLoading, loading => loading.markingAsRead);
